document.addEventListener("DOMContentLoaded", function () {
  function startReveal() {
    var items = document.querySelectorAll(".cc-reveal");

    if (!items.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("cc-visible");
        }
      });
    }, {
      threshold: 0.15
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  startReveal();

  document.addEventListener("shopify:section:load", startReveal);
});